import {
  type DocumentClassification,
  type DocumentFailureReason,
  DocumentFailureReasonSchema,
  type DocumentVideoAnalysis,
} from "@recobra/schemas/document";

export type ClassificationEvent =
  | { documentId: string; status: "uploaded" }
  | { documentId: string; status: "classifying" }
  | {
      documentId: string;
      status: "classified";
      classification?: DocumentClassification;
      videoAnalysis?: DocumentVideoAnalysis;
      thumbnailKey?: string;
    }
  | { documentId: string; status: "failed"; failureReason?: DocumentFailureReason };

export const isClassificationEvent = (data: unknown): data is ClassificationEvent => {
  if (typeof data !== "object" || data === null) return false;
  if (!("documentId" in data) || !("status" in data)) return false;
  if (typeof data.documentId !== "string") return false;
  const { status } = data;

  if (status === "failed") {
    return (
      !("failureReason" in data) ||
      DocumentFailureReasonSchema.safeParse(data.failureReason).success
    );
  }

  return status === "uploaded" || status === "classifying" || status === "classified";
};
